module.exports = __webpack_public_path__ + "img/tax.eb4cc220.svg";